export enum BannerFilterEnum {
  All = 2,
  Published = 1,
  Unpublished = 0
}
